export const AgencyCode = {
	cleverly: 'cleverly',
	prosocial: 'prosocial',
} as const;

const CleverlyCodes: ReadonlyArray<string> = [AgencyCode.cleverly];
/**
 * Check if platform is cleverly
 * @param isAgency
 * @param agencyCode
 * @returns Whether platform is cleverly
 */
export function isCleverly(isAgency: boolean, agencyCode: string): boolean {
	return isAgency === true && CleverlyCodes.includes(agencyCode);
}
